type Props = { step: number; total: number };

export function ProgressBar({ step, total }: Props) {
  const pct = Math.round((step / total) * 100);
  return (
    <div className="mb-6">
      <div className="flex justify-between mb-2">
        <span className="gcm-eyebrow">
          Round {step} of {total}
        </span>
        <span className="gcm-eyebrow">{pct}%</span>
      </div>
      <div className="h-1.5 w-full bg-surface-sunken rounded-full overflow-hidden">
        <div
          className="h-full bg-gcm-red transition-[width] duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
